/** @fileoverview Parses tenant, app, and builder routes in Fabrik. */

function decodeRoutePart(value: string | undefined) {
  try {
    return decodeURIComponent(value || '');
  } catch {
    return '';
  }
}

export function getFabrikRoute(pathname: string) {
  const isNewAppRoute = /^\/t\/[^/]+\/apps\/new\/?$/.test(pathname);

  return {
    tenantId: decodeRoutePart(pathname.match(/^\/t\/([^/]+)/)?.[1]),
    appId: decodeRoutePart(pathname.match(/^\/t\/[^/]+\/apps\/([^/]+)/)?.[1]),
    isNewAppRoute,
    isPreviewRoute: /^\/t\/[^/]+\/apps\/[^/]+\/preview\/?$/.test(pathname),
    isAppEditRoute: /^\/t\/[^/]+\/apps\/[^/]+\/?$/.test(pathname) && !isNewAppRoute,
  };
}
